<script lang="ts">
  import { page } from '$app/stores';
  import { Wrapper, Paragraph, Heading } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties}
    <div class="wrapper">
      <div
        class="section-container"
        id={properties?.anchor}
        style=" justify-content: {properties.textAlignment};"
      >
        <div class="text-section">
          {#if properties.heading}
            <Heading type={'h1'} css={'margin-top:10px;margin-bottom:15px;'}>
              {@html properties.heading}
            </Heading>
          {/if}

          {#if properties.text}
            {#if $page.data?.pageType === 'marketing'}
              <p>{@html properties.text}</p>
            {:else}
              <Paragraph>{@html properties.text}</Paragraph>
            {/if}
          {/if}
        </div>
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .section-container {
    height: auto;
    padding: 0px;
    display: flex;
    max-width: 1300px;
    margin-right: auto;
    margin-left: auto;
    border-radius: 8px;
  }
  .text-section {
    text-align: center;
    width: 100%;
    max-width: 900px;
    word-break: break-word;
  }
  .wrapper {
    padding: 15px;
  }
</style>
